import { useSessionStorage } from '@wolfdanepug/common-react'
import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router'

export default function Session() {
	const [session] = useSessionStorage('session', '')
	const navigate = useNavigate()

	useEffect(() => {
		!session && navigate('/')
	}, [session])

	return (
		<>
			<Outlet />
		</>
	)
}
